<template>
    <div class='personalCenter_wrap'>
        <div class='header_wrap'>
            <div class='header_top flex-column-content'>
                <div>
                    <el-avatar :size='100'
                               src='https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'></el-avatar>
                </div>
                <div class='user_name'>{{ personalInfo.userName }}</div>
                <div>
                    <span>{{ personalInfo.schoolName }}</span>
                    <el-divider class='ml20' direction='vertical'></el-divider>
                    <span>{{ personalInfo.occupation }}</span>
                    <i class='iconfont icon-bianji' @click='toPersonalSet'></i>
                </div>
            </div>
            <div class="header_bar flex-between">
                <div class="bar_wrap flex-between">
                    <div class="active_item" @click="changeNav(0)">
                        <div class="active_text">任务</div>
                        <div v-if="modeId == 0" :class="{active:modeId == 0}"></div>
                        <div v-else style="height:20px"></div>
                    </div>
                    <div class="active_item" @click="changeNav(1)">
                        <div class="active_text">课程</div>
                        <div v-if="modeId == 1" :class="{active:modeId == 1}"></div>
                        <div v-else style="height:20px"></div>
                    </div>
                    <div class="active_item" @click="changeNav(2)">
                        <div class="active_text">收藏</div>
                        <div v-if="modeId == 2" :class="{active:modeId == 2}"></div>
                        <div v-else style="height:20px"></div>
                    </div>
                    <div class="active_item" @click="changeNav(3)">
                        <div class="active_text">通知</div>
                        <div v-if="modeId == 3" :class="{active:modeId == 3}"></div>
                        <div v-else style="height:20px"></div>
                    </div>
                    <div class="active_item" @click="changeNav(4)">
                        <div class="active_text">问卷</div>
                        <div v-if="modeId == 4" :class="{active:modeId == 4}"></div>
                        <div v-else style="height:20px"></div>
                    </div>
                </div>
                <div class="flex-end manage_button_wrap">
                    <div v-if="personalInfo.occupation == '管理员'" class="header_right" @click="enterBackManage">
                        后台管理系统
                    </div>
                    <div v-if="personalInfo.occupation == '老师' || personalInfo.occupation == '管理员'" class="header_right" @click="enterTeaManage">
                        教师后台管理
                    </div>
                    <div class="header_right" @click="isStartVisible = true">
                        开启实验环境
                    </div>
                </div>
            </div>
        </div>
        <div class="content_wrap">
            <!-- 任务内容 -->
            <PersonTask v-show="modeId == 0" ref="task"></PersonTask>
            <!-- 课程列表 -->
            <Course v-show="modeId == 1" ref="course"></Course>
            <!-- 收藏内容 -->
            <Collection v-show="modeId == 2" ref="collect"></Collection>
            <!-- 通知内容 -->
            <Notice v-show="modeId == 3" ref="notice"></Notice>
            <!-- 问卷调查 -->
            <Investigation v-show="modeId == 4" ref="investigation"></Investigation>
        </div>
        <!-- 进入实验环境 -->
        <el-dialog title='注意' :visible.sync='isStartVisible' width='30%' center>
            <span>是否立即启动实验环境？</span>
            <span slot='footer' class='dialog-footer'>
              <el-button type='primary' @click='startLab'>是</el-button>
              <el-button @click='isStartVisible = false'>否</el-button>
            </span>
        </el-dialog>
        <!-- 未具备购买权限-->
        <el-dialog title='注意' :visible.sync='isBuyVisible' width='37%' center>
            <i class='iconfont icon-gantanhao' style='color:#DB1C08;font-size:18px'></i><span class='notice_text_grey'>&nbsp;您所在的单位还没有购买此内容，有需要请与您的单位联系？</span>
            <span slot='footer' class='dialog-footer'>
              <el-button type='primary' @click='isBuyVisible = false'>关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

import { setIsRead } from '../../../utils/api';

export default {
    data() {
        return {
            currentNotice: [],//当前删除通知
            activeName: 'first',
            modeId: 0,//导航栏目id
            personalInfo: {
                avatar: this.$store.state.userAvatar,
                userName: this.$store.state.userName,
                schoolName: this.$store.state.schoolName,
                occupation: this.$store.state.roleName
            },
            noticeName: '',
                noticeContent:{
                    noticeTime: '',
                    publicUser: '',
                    briefText: '',
                    noticeId: '',
                    noticeText: ''
                },
            deleteNoticeVisible: false,
            cancelCollectVisible: false,
            isStartVisible: false,
            isBuyVisible: false
        }
    },
    mounted() {
        this.$route.query.modeId && this.changeNav(this.$route.query.modeId);
    },
    methods: {
        //进入后台管理系统
        enterBackManage() {
            location.href = `${this.$config.SYSTEM_URL}/manage`;
        },

        //开启实验环境
        startLab() {
            this.isStartVisible = false;
            window.open(`${this.$config.SYSTEM_URL}/hub`);
        },

            //进入教师管理页面
            enterTeaManage(){
                location.href = `${this.$config.SYSTEM_URL}/server`
            },

            //更改导航栏
            changeNav(id){
                this.modeId = id
                if(id == 0){
                    this.$refs.task.getClassTask()
                }
                if(id == 1){
                    this.$refs.course.getCourseList()
                }
                if(id == 2){
                    this.$refs.collect.getCollectData()
                }
                if(id == 3){
                    this.$refs.notice.getNoticeList()
                }
                if(id == 4){
                    this.$refs.investigation.getInvestigationList()
                }
            },

            //去通知子页面,id为0时是任务通知列表，为1时是系统通知列表
            toSubNotice(val,id){
                if(id == 0){
                    this.noticeName = val.assignmentTitle
                    this.noticeContent.noticeTime = val.startTime
                    this.noticeContent.publicUser = val.teacherName
                    this.noticeContent.noticeText = val.richText
                    this.noticeContent.noticeId = val.assignmentId
                    this.modeId = 2
                }else{
                    this.noticeName = '通知'
                    this.noticeContent.noticeTime = val.sendTime
                    this.noticeContent.publicUser = val.senderName
                    this.noticeContent.noticeText = val.noticeContent
                    this.noticeContent.noticeId = val.noticeId;
                    setIsRead({ noticeIds: val.noticeId }).then(res => {
                    }).catch(err => {
                    });
                }

            },

        //去个人设置
        toPersonalSet() {
            this.$router.push('/modifyInfo');
        }
    }
}
</script>
<style lang="scss" scoped>
/deep/.el-avatar--circle {
    border: 3px solid white;
}
.personalCenter_wrap{
    background: #F3F6FF;
    /deep/.el-dialog__header{
        background: #5277F7;
        height: 30px;
        .el-dialog__title{
            color: white;
        }
        .el-dialog__headerbtn .el-dialog__close{
            color: white;
        }
    }
    /deep/.el-dialog--center .el-dialog__body{
        padding: 25px 100px 30px;
    }
}
.content_wrap{
    box-sizing: border-box;
    padding: 0px 250px;
}

.header_wrap{
    height: 420px;
    width: 100%;
    color: #FFFFFF;
    background: url(../../../assets/img/bar.png) 0 0/100% 100% no-repeat;
    // background: red;
    .header_top{
        height: 360px;
        box-sizing: border-box;
        text-align: center;
        justify-content: center;
        line-height: 1.8;

        .icon-bianji{
            margin-left: 5px;
        }
        .icon-bianji:hover{
            opacity: 0.9;
        }
        .user_name{
            margin: 0px 20px;
            text-align: center;
            font-size: 35px;
        }

    }
    .header_bar{
        height: 60px;
        line-height: 40px;
        .manage_button_wrap{
             width: 50%;
        .header_right:hover{
                cursor: pointer;
                opacity: 0.9;
            }
            .header_right{
                height: 40px;
                width: 150px;
                margin-right: 20px;
                line-height: 40px;
                color: #5277F7;
                text-align: center;
                font-weight: 600;
                border-radius: 5px;
                background: white
            }
        }

        .bar_wrap{
            width: 50%;
            margin:auto;
            padding: 0px 5%;
            .active_item:hover{
                opacity: 0.8;
            }
            .active_item{
                cursor: pointer;
                position: relative;
                bottom: -5px;
                .active_text{
                    position: relative;
                    left:-30px;
                    width: 80px;
                    font-size: 20px;
                    letter-spacing: 2px;
                    text-align: center;
                    height: 30px;
                }
                .active{
                    width: 1px;
                    position: relative;
                    // bottom: -10px;
                    text-align: center;
                    box-sizing: border-box;
                    border-width:10px;
                    border-style:solid;
                    border-bottom-width:10px;
                    border-color:transparent transparent #F3F6FF transparent;
                }
            }

        }
    }
}
</style>
